import * as React from "react"
import {Layout} from "../components/Layout";
import {Expertises} from "../screens/expertises/expertises";
import {graphql, useStaticQuery} from "gatsby";
import {translate} from "../helpers/lang";
import {Seo} from "../components/Seo";

const ExpertisesPage = ({pageContext ,location}) => {
  const {lang, alternativePath} = pageContext ;

  const data = useStaticQuery(graphql`
  {
    allHome {
      edges {
        node {
#          dataexpertisesseoimage {
#            childImageSharp {
#              fixed {
#                src
#              }
#            }
#          }
          data {
            expertises {
              seo {
                description {
                  en
                  fr
                }
                title {
                  en
                  fr
                }
              }
            }
            title {
              en
              fr
            }
          }
        }
      }
    }
  }
`)


  const seoT = translate(lang, data?.allHome?.edges?.[0]?.node?.data?.expertises?.seo );
  const titleT = translate(lang, data?.allHome?.edges?.[0]?.node?.data);
  const seo ={
    image: 'image',
    seoTitle:seoT('title') ,
    title:titleT('title'),
    description:seoT('description'),
    lang
  }

    return (
        <Layout path={location.pathname}  alternativePath={alternativePath}  lang ={lang}>
          <Seo {...seo}/>
            <Expertises lang={lang}/>
        </Layout>
    )
}

export default ExpertisesPage;
